module.exports = __webpack_public_path__ + "static/media/lottery_lattice.ed26d135.png";